module.exports = __webpack_public_path__ + "img/image.dac34922.png";